/* epi-product-row.js
   Handles arrow + scroll state for horizontal product rows
   (Featured Products + Related Products).
   Uses event delegation so it survives AJAX innerHTML replacement
   (used by <product-recommendations> on the PDP). */

(function () {
  function updateArrows(list) {
    var wrap = list.closest('.epi-featured-products__scroll-wrap');
    if (!wrap) return;
    var prev = wrap.querySelector('.epi-featured-products__arrow--prev');
    var next = wrap.querySelector('.epi-featured-products__arrow--next');
    var atStart = list.scrollLeft <= 2;
    var atEnd = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
    if (prev) prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
    if (next) next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
  }

  function bindList(list) {
    if (list.dataset.epiRowBound === '1') return;
    list.dataset.epiRowBound = '1';
    list.addEventListener('scroll', function () { updateArrows(list); }, { passive: true });
    updateArrows(list);
  }

  function scanAll(root) {
    (root || document).querySelectorAll('.epi-featured-products__list').forEach(bindList);
  }

  document.addEventListener('click', function (e) {
    var arrow = e.target.closest && e.target.closest('.epi-featured-products__arrow');
    if (!arrow) return;
    var wrap = arrow.closest('.epi-featured-products__scroll-wrap');
    if (!wrap) return;
    var list = wrap.querySelector('.epi-featured-products__list');
    if (!list) return;
    var direction = arrow.classList.contains('epi-featured-products__arrow--prev') ? -1 : 1;
    list.scrollBy({ left: direction * list.clientWidth * 0.8, behavior: 'smooth' });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scanAll(); });
  } else {
    scanAll();
  }

  new MutationObserver(function (records) {
    records.forEach(function (r) {
      r.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('.epi-featured-products__list')) bindList(node);
        if (node.querySelectorAll) scanAll(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
